import { ReactId } from "reactjs-id";

const getElementID = () => {
  return ReactId();
};

export {
  getElementID,
};